import { EventEmitter } from "events";
import { authWithPhone } from "./index";
import { logPhoneAuthError } from "./phoneAuthDiagnostics";

export default class AuthPhone extends EventEmitter {
  constructor(phoneNumber) {
    super();
    this.phoneNumber = phoneNumber;
  }

  async getCode() {
    this.enterCodeFunc = await authWithPhone(this.phoneNumber);

    this.emit("code-sent");
  }

  async enterCode(code) {
    if (this.enterCodeFunc) {
      let authResult;

      try {
        authResult = await this.enterCodeFunc(code);
      } catch (error) {
        logPhoneAuthError(this.phoneNumber, error, console, "confirm-code");
        throw error;
      }

      this.emit("auth-success", authResult);
    }
  }
}
